/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AddTaxRateV2Dto as DigiworkMaitreDPosDtoTaxRatesV2AddTaxRateV2Dto } from '../../models/Digiwork/MaitreD/Pos/DTO/TaxRatesV2/add-tax-rate-v-2-dto';
import { TaxRateV2Dto as DigiworkMaitreDPosDtoTaxRatesV2TaxRateV2Dto } from '../../models/Digiwork/MaitreD/Pos/DTO/TaxRatesV2/tax-rate-v-2-dto';

export interface AddTaxRate$Params {
      body?: DigiworkMaitreDPosDtoTaxRatesV2AddTaxRateV2Dto
}

export function addTaxRate(http: HttpClient, rootUrl: string, params?: AddTaxRate$Params, context?: HttpContext): Observable<StrictHttpResponse<DigiworkMaitreDPosDtoTaxRatesV2TaxRateV2Dto>> {
  const rb = new RequestBuilder(rootUrl, addTaxRate.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<DigiworkMaitreDPosDtoTaxRatesV2TaxRateV2Dto>;
    })
  );
}

addTaxRate.PATH = '/api/tax-rates';
